<template>
    <div>
        <Bar :chart-options="chartOptions" :chart-data="chartData" :height="400" />
    </div>
</template>
  
<script>
import { Bar } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import moment from 'moment';
import dashboard from '../../apis/dashboard';
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
const COLORS = [
    '#4dc9f6',
    '#f67019',
    '#f53794',
    '#537bc4',
    '#acc236',
    '#166a8f',
    '#00a950',
    '#58595b',
    '#8549ba'
];

export default {
    name: 'BarChart',
    components: { Bar },
    data() {
        return {
            chartData: {
                labels: ['January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December'],
                datasets: [
                    {
                        label: 'DISBURSEMENT',
                        backgroundColor: COLORS[0],
                        data: []
                    },
                    {
                        label: 'REPAYMENT (PRINCIPAL)',
                        backgroundColor: COLORS[1],
                        data: []
                    },
                    {
                        label: 'INTEREST',
                        backgroundColor: COLORS[2],
                        data: []
                    }
                ]
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    filler: {
                        propagate: false,
                    },
                    legend: {
                        position: 'top',
                    },
                    title: {
                        display: true,
                        text: `DISBURSEMENT - REPAYMENT (PRINCIPAL) - INTEREST \n ${moment().format('YYYY')}`
                    }
                },
            },
        }
    },
    async mounted() {
        this.loaded = false
        try {
            const labels_ =this.chartData.labels;
            const list = await dashboard.disbursementvsrepaymentmonthly();
            for (let index = 0; index < 3; index++) {
                const listDt = list[index] || [];
                if(listDt.length>0){
                    let datas = [];
                    for (let idx = 0; idx < labels_.length; idx++) {
                        const element = labels_[idx];
                        let obj = { 'x': element, 'y': 0 };
                        const findDt = listDt.find(x => x.monthname== element);
                        if(findDt){
                            obj.y = findDt.amount_summary;
                        }
                        datas.push(obj);
                    }
                    this.chartData.datasets[index].data =datas;
                }

            }
            // crud.list(this.tblData).then((list) => {
            //     const data = periode.reduce((arr = [], dt, idx) => {
            //         const findDt = list.find(x => moment(x.disbursed_date).format('YYYY-MM-DD') == dt);
            //         let obj = { 'x': moment(dt).format('DD MMM'), 'y': 0 };
            //         labels_.push(moment(dt).format('DD MMM'))
            //         if (findDt) {
            //             obj.y = findDt.loan_amount
            //         }
            //         arr.push(obj);
            //         return arr;
            //     }, []);
            //     setTimeout(() => {
            //         this.chartData.labels = labels_;
            //         this.chartData.datasets[0] = {
            //             label: 'Reimbursement',
            //             borderColor: '#f87979',
            //             backgroundColor: '#f87979',
            //             data,
            //             fill: false
            //         };
            //         // this.renderChart(this.chartData, this.chartOptions);
            //     }, 1000);
            // })


            this.loaded = true
        } catch (e) {
            this.loaded = true
            console.error(e)
        }
    },
}
</script>
  